$("html").on('languageChanged', function(){
  $(".lang-select").each(function(){
    if($(this).data('lang') == selectedLang){

      $(this).css('display', 'none');
    }
    else{
      $(this).css('display', 'inline');
    }
  });
  console.log('hi from langCustom.js, ', selectedLang);
  
  jQuery.post('/cart/update.js', "attributes[Language]=" + selectedLang, function(){}, "json");
});